import api from './api';
import { ENDPOINTS } from './endpoints';

export const getStudentSubjectMappingList = async (session_id, program_id, subject_id) => {
  try {
    const response = await api.get(`${ENDPOINTS.STUDENT_SUBJECT_MAPPING.GET}`, { params: { program_id, subject_id, session_id } });
    return response;
  } catch (error) {
    throw error;
  }
}

export const createStudentSubjectMapping = async (data) => {
  try {
    const response = await api.post(ENDPOINTS.STUDENT_SUBJECT_MAPPING.CREATE, { data });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStudentSubjectMapping = async (data) => {
  try {
    const response = await api.put(`${ENDPOINTS.STUDENT_SUBJECT_MAPPING.UPDATE}`, { data });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudentEnrolledSubjects = async (student_id, program_id) => {
  try {
    const response = await api.get(`${ENDPOINTS.STUDENT_SUBJECT_MAPPING.GET_STUDENT_ENROLLED_SUBJECTS}/${student_id}/${program_id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const createStudentSubjectsEnrollment = async (data) => {
  try {
    const response = await api.post(`${ENDPOINTS.STUDENT_SUBJECT_MAPPING.STUDENT_ENROLL_INTO_SUBJECTS}`, { data });
    return response;
  } catch (error) {
    throw error;
  }
}

export const getStudentCountSubjectWise = async (program_id) => {
  try {
    const response = await api.get(`${ENDPOINTS.STUDENT_SUBJECT_MAPPING.GET_STUDENT_COUNT_SUBJECT_WISE}/${program_id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

